module.exports = __webpack_public_path__ + "static/img/Kiss.959576e3.png";